import React from "react";
import RuleProduct from "./RuleProduct.jsx";
import LoadingSpinner from "../../atoms/loadingSpinner/LoadingSpinner.jsx";

export function LikedProductsList({
  userLikedProducts,
  handleQts,
  logoSmallUrl,
  delivery,
  fetchPreferencesAndRules,
  fetchCatalog,
  fetchDelivery,
  timeslotsBeforeOrdering,
  isLoadingPreferencesAndRules,
}) {

  return (
    <div className="rule__proposal_cards">
      {isLoadingPreferencesAndRules ? (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "150px",
          }}>
          <LoadingSpinner
            isLoading={true}
            clazzName="rule__loading_cards"
            applyStylesToMain={true}
          />
        </div>
      ) : (
        userLikedProducts.map((item, index) => (
          <RuleProduct
            key={`rule-product-${item.id}-${index}`}
            item={item}
            handleQts={handleQts}
            logoSmallUrl={logoSmallUrl}
            delivery={delivery}
            timeslotsBeforeOrdering={timeslotsBeforeOrdering}
            fetchPreferencesAndRules={fetchPreferencesAndRules}
            fetchCatalog={fetchCatalog}
            fetchDelivery={fetchDelivery}
          />
        ))
      )}
    </div>
  );
}
